import { HealthTeam } from "@/@types/esus/HealthTeam";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorC5ByHealthTeamParams = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorC5ByHealthTeamData {
	healthTeam?: HealthTeam;
	totalHypertensiveCitizensInPeriod: number = 0;
	totalHypertensiveCitizensInPeriodScore: number = 0;
	maxHypertensiveCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC5ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorC5ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorC5ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c5/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorC5ByHealthTeamData>();
}
